import withStyles from 'isomorphic-style-loader/lib/withStyles';

import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';

import References from '../../../components/Help/Demographics/References';

import s from './HighSchoolStudentsSection.scss';

class HighSchoolStudentsSection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Panel>
          <Panel.Heading>High School Students</Panel.Heading>
          <Panel.Body>
            <p>
              Nearly every high school student faces the same dilemma come
              senior year: what to study in college. It's an expensive and
              highly impactful decision. Unfortunately, according to a national
              survey in 2015, while the vast majority of students want to go to
              college, few feel prepared to do so. Only 46 percent said their
              school helped them figure out which careers matched their
              interests and abilities and only 49 percent said their school
              helped them understand the steps they need to take in order to
              have the career they want.
              <span className={s.cite}>1</span> These numbers paint a sobering
              picture of the state of career readiness in America.
              <br />
              <br />
              To figure it all out, some students choose to job shadow, which is
              a great idea. Not only do admissions committees and future
              employers love seeing job shadow experiences on resumes, but job
              shadowing also provides students with invaluable work experience
              without requiring them to spend every day of summer break on the
              job.
              <span className={s.cite}>2</span> Unfortunately, when it comes to
              conventional job shadowing, very few online resources exist to
              connect students to professionals and those that do, typically a
              local career resource center or college, often present the
              information in an unhelpful, non-intuitive manner. Typically,
              these shadowing opportunities focus almost exclusively on
              traditional, academic-based careers such as a lab technician or
              nurse and rarely dive into the creative arts.
              <br />
              <br />
              Conventional job shadowing is a daunting experience. Cold-calling
              businesses to set up a shadowing appointment is not only awkward
              but highly inefficient, requiring constant communication and
              coordination. On top of that, the professional does not receive
              much benefit for giving up his or her time. In general, job
              shadowing follows this format: research industries of interest,
              create a list of companies, find one you think might work,
              cold-call or cold-email a specific employee, know what to ask,
              talk logistics, do more research in preparation, show up and pray
              you learn something. What a hassle.
              <br />
              <br />
              Shadower minimizes or eliminates that process altogether: no more
              nervous cold calling, no more unanswered emails, no more digging
              around the web lost and confused. With Shadower, high school
              students can research career paths across a range of fields on a
              clean, organized and intuitive platform. They'll find people who
              truly want to be shadowed, people who want to share their passions
              with a wider audience. On top of all that, they'll be able to job
              shadow far more frequently. Before Shadower, shadowing someone new
              each day would not be logistically possible.
              <br />
              <br />
              For parents, it is a fantastic opportunity and one that could save
              them from spending a massive amount of money supporting a child
              unable to find the right major in college. Inside the U.S., 67
              precent of parents have paid or would consider paying for tutoring
              for their child, according to HSBC, so there is certainly a market
              for Shadower among parents looking to supplement their child's
              education.
              <span className={s.cite}>3</span>
            </p>

            <References
              referenceList={
                <div>
                  <ol>
                    <li>
                      <a
                        href="http://youthtruthsurvey.org/wp-content/uploads/2016/01/YouthTruth-Learning-From-Student-Voice-College-and-Career-Readiness-2016.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        YouthTruth Student Survey (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Most High Schoolers Feel Unprepared for College and
                        Careers.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.fastweb.com/career-planning/articles/how-to-arrange-and-conduct-a-job-shadow"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        FastWeb (2018)
                      </a>
                      ,&nbsp;
                      <i>How to Manage and Conduct a Job Shadow.</i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/524033/parents-children-tutoring-pay/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        HSBC (2018)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of parents who have paid or would pay for tutoring
                        for their child in selected countries in 2015.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://nces.ed.gov/pubs2018/2018434.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2017)
                      </a>
                      ,&nbsp;
                      <i>
                        College students tend to change majors when they find
                        the one they really love.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/731339/factors-that-would-have-helped-students-to-feel-more-prepared-for-their-careers-us/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Hanover Research, McGraw-Hill (2017)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of factors that would have made students feel more
                        prepared for their careers in the United States in 2017.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.chronicle.com/article/What-s-Wrong-With-Required/242727"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        The Chronicle of Higher Education (2018)
                      </a>
                      ,&nbsp;
                      <i>What's Wrong with Required Internships?</i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/673316/top-fields-for-internship-positions/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        New York Times, Burning Glass (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Occupational fields with the largest number of
                        internship postings in the United States from September
                        2015 to October 2016.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.burning-glass.com/research-project/internships-2015/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Burning Glass (2015)
                      </a>
                      ,&nbsp;
                      <i>
                        No Experience Necessary? The State of American
                        Internships 2015.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/782547/number-of-schools-offering-occupational-education-us-by-state/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2013)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of postsecondary schools offering occupation
                        education in the U.S. in 2013, by state.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://highered.colorado.gov/Data/InstSelect.aspx"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        CHDE (2017)
                      </a>
                      ,&nbsp;
                      <i>Search Colleges and Universities.</i>
                    </li>

                    <li>
                      <a
                        href="https://nces.ed.gov/programs/digest/d17/tables/dt17_105.50.asp?current=yes"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of educational institutions, by level and control
                        of institution: Selected years, 1980-81 through 2015-16.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/782528/number-of-schools-offering-occupational-education-us-by-school-type/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of postsecondary schools offering occupational
                        education in the U.S. from 2000 to 2014, by school type.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334116/reasons-for-us-online-non-degree-classes-by-age/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        U.S. online learner reasons for taking online non-degree
                        classes as of January 2014, by age.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334033/us-online-classes-tutorial-usage-income-levels/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by income
                        levels.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334040/us-online-classes-tutorial-usage-education-levels/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by education
                        levels.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/184236/us-online-classes-tutrial-usage-age/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by age.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/862627/us-employment-market-sources-of-new-opportunities-for-jobseekers/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Jobvite (2018)
                      </a>
                      ,&nbsp;
                      <i>
                        Main sources to learn of new opportunities for U.S. job
                        seekers in 2018.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.payscale.com/research/US/Job=Small_Business_Owner/Salary"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        REF (2017)
                      </a>
                      ,&nbsp;
                      <i>Small Business Owner Salary.</i>
                    </li>
                  </ol>
                </div>
              }
              referenceTitle="References"
            />
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(HighSchoolStudentsSection);
